import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Tab,
  Tabs,
  TablePagination,
} from '@mui/material';
import useTabs from 'src/hooks/useTabs';
import useAuth from 'src/hooks/useAuth';
import useTable, { emptyRows } from 'src/hooks/useTable';
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import { TableEmptyRows, TableNoData } from 'src/components/table';
import { useDispatch, useSelector } from 'src/redux/store';
import { validaLabelMenuDatas } from 'src/utils/functions';
import v2_actionListaChatsSupervisao from 'src/actions/v2/dashboard/supervisao/v2_actionListaChatsSupervisao';
import moment from 'moment';
import SupervisaoRow from 'src/sections/@dashboard/supervisao/SupervisaoRow';
import SupervisaoChatItem from 'src/sections/@dashboard/supervisao/SupervisaoChatItem';
import ChatWindow from 'src/sections/@chats/chat/ChatWindow';
import { getListaSetoresTransferencia, getListaUsuariosTransferencia } from 'src/redux/slices/user';
import { getMensagensWhatsappDb, setChatInfo, setLimparChatInfo } from 'src/redux/slices/chat';
import v2_actionBuscarChatById from 'src/actions/v2/services/chats/v2_actionBuscarChatById';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import DrawerChatWhatsapp from 'src/sections/@chats/chat/DrawerChatWhatsapp';
import v2_actionListaTagsChats from 'src/actions/v2/chats/v2_actionListaTagsChats';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from 'src/@/components/ui/select';
import { Popover, PopoverContent, PopoverTrigger } from 'src/@/components/ui/popover';
import MenuDatas2 from 'src/components/MenuDatas2';
import { Input } from 'src/@/components/ui/input';
import { TableHead, Table, TableBody, TableHeader } from 'src/@/components/ui/table';
import { cn } from 'src/@/lib/utils';
import { SupervisaoExport } from 'src/sections/@dashboard/supervisao/SupervisaoExport';
import v2_actionGerarExcelRelatorioChats from 'src/actions/v2/dashboard/relatorios/excel/v2_actionGerarExcelRelatorioChats';
import SkeletonSupervisionList from 'src/@/components/use/skeleton/SkeletonDashboardPage';
import v2_actionGerarExcelRelatorioChatsPrimeiroContato from 'src/actions/v2/dashboard/relatorios/excel/v2_actionGerarExcelRelatorioChatsPrimeiroContato';
import { SUPERVISAO_LISTA_DESIGN as D } from './SupervisaoLista.design';


const TABLE_HEAD = [
  { id: 'statusRoom', label: 'Status' },
  { id: 'numeroCliente', label: 'Numero' },
  { id: 'usuario_canal', label: 'Usuário' },
  { id: 'nome_contato', label: 'Nome do chat' },
  { id: 'nome_usuario', label: 'Atendente' },
  { id: 'nome_setor', label: 'Setor' },
  { id: 'lastUpdate', label: 'Ultima Atividade' },
  { id: 'dataCriacao', label: 'Data Criação' },
  { id: 'chatbot', label: 'Chatbot' },
  { id: 'sentimento', label: 'Sentimento' },
  { id: '' },
];

const STATUS_OPTIONS = [
  { value: null, label: "Todos" },
  { value: 'Atendendo', label: "Atendendo" },
  { value: 'Pendente', label: "Em fila" },
  { value: 'Finalizado', label: "Finalizados" },
  { value: 'Geral', label: "No bot" },
  { value: 'Avaliando', label: "Avaliando" }
];

const STATUS_SIDEBAR_OPTIONS = [
  { value: null, label: "Todos", icon: "mdi:forum-outline", dot: "bg-gray-400", activeBg: "bg-[#7C3AED]/10", activeBorder: "border-[#7C3AED]", activeIcon: "text-[#7C3AED]", activeLabel: "text-[#7C3AED]" },
  { value: 'Atendendo', label: "Atendendo", icon: "mdi:headset", dot: "bg-amber-500", activeBg: "bg-amber-50", activeBorder: "border-amber-500", activeIcon: "text-amber-600", activeLabel: "text-amber-700" },
  { value: 'Pendente', label: "Em fila", icon: "mdi:clock-fast", dot: "bg-red-500", activeBg: "bg-red-50", activeBorder: "border-red-500", activeIcon: "text-red-600", activeLabel: "text-red-700" },
  { value: 'Finalizado', label: "Finalizados", icon: "mdi:check-circle-outline", dot: "bg-emerald-500", activeBg: "bg-emerald-50", activeBorder: "border-emerald-500", activeIcon: "text-emerald-600", activeLabel: "text-emerald-700" },
  { value: 'Geral', label: "No bot", icon: "mdi:robot-happy-outline", dot: "bg-blue-500", activeBg: "bg-blue-50", activeBorder: "border-blue-500", activeIcon: "text-blue-600", activeLabel: "text-blue-700" },
  { value: 'Avaliando', label: "Avaliando", icon: "mdi:star-half-full", dot: "bg-purple-500", activeBg: "bg-purple-50", activeBorder: "border-purple-500", activeIcon: "text-purple-600", activeLabel: "text-purple-700" },
];

// ----------------------------------------------------------------------

export default function SupervisaoLista() {
  const dispatch = useDispatch();
  const location = useLocation();

  const {
    dense,
    page,
    rowsPerPage,
    setPage,
    selected,
    onSelectRow,
    onChangePage,
    onChangeRowsPerPage,
  } = useTable({ defaultOrderBy: 'date_created', defaultRowsPerPage: 25 });

  const { listaUsuariosTransferencia, listaSetoresTransferencia } = useSelector((state) => state.user);
  const { listaFunil, chatInfo } = useSelector((state) => state.chat);
  const { user, cliente } = useAuth();
  const [filterName] = useState('');
  const [filterPesquisa, setFilterPesquisa] = useState('');
  const { currentTab: filterStatus, onChangeTab: onChangeFilterStatus } = useTabs(null);
  const [inicio, setInicio] = useState(new Date());
  const [final, setFinal] = useState(new Date());
  const [periodo, setPeriodo] = useState('mes_atual')
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenuDatas = Boolean(anchorEl);
  const [valorEscolhidoUsuario, setValorEscolhidoUsuario] = useState("");
  const [valorEscolhidoSetor, setValorEscolhidoSetor] = useState("");
  const [valorEscolhidoSentimento, setValorEscolhidoSentimento] = useState("");

  const [chat, setChat] = useState(null);
  const [openChatdetalhes, setOpenChatDetalhes] = useState(false);
  const [loadingListaChats, setLoadingListaChats] = useState(false);
  const [isPesquisado, setIsPesquisado] = useState(false);
  const [listaChatsPesquisa, setListaChatsPesquisa] = useState([]);
  const [listaChatsFiltro, setListaChatsFiltro] = useState([]);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const tableData = isPesquisado ? listaChatsPesquisa : listaChatsFiltro;
  const [loadingVerDetalhes, setLoadingVerDetalhes] = useState(false);


  const [listaClientesCanais, setListaClientesCanais] = useState([]);
  const isMultisession = cliente.multiSession === 1;
  const [listaTags, setListaTags] = useState([]);
  const [clienteIdPadrao, setClienteIdPadrao] = useState(isMultisession ? null : user.clienteId);
  const [valorEscolhidoTag, setValorEscolhidoTag] = useState("");
  const [viewMode, setViewMode] = useState('table'); // 'table' | 'split'



  async function buscarListaClientesCanais() {
    try {
      const response_clientes_canais = await actionListaClientesCanais(cliente._id)
      setListaClientesCanais(response_clientes_canais.data.data);
      if (isMultisession) {
        setClienteIdPadrao(response_clientes_canais.data.data[0].cliente_id);
      }
    } catch (err) {
      console.log(err)
    }
  }

  async function buscarListaTags() {
    try {
      let querys = `?cliente_id=${user.clienteId}`
      const response = await v2_actionListaTagsChats(querys);
      setListaTags(response.data.data)
    } catch (error) {

    }
  }


  async function buscarListaChats(querys, action, isPesquisado) {
    if (!clienteIdPadrao) return;
    setLoadingListaChats(true);
    if (action === 'pesquisar' && !filterPesquisa) {
      alert("Campo de pesquisa está vazio!");
      return;
    }

    try {
      // Adicionar filtros na query apenas quando não estiver pesquisando
      let filtersQuery = querys;

      if (!isPesquisado) {
        if (valorEscolhidoUsuario) {
          filtersQuery += `&filterUser=${valorEscolhidoUsuario}`;
        }

        if (valorEscolhidoSetor) {
          filtersQuery += `&filterDepartament=${valorEscolhidoSetor}`;
        }

        if (valorEscolhidoTag) {
          filtersQuery += `&filterTag=${valorEscolhidoTag}`;
        }

        if (valorEscolhidoSentimento) {
          filtersQuery += `&filterSentiment=${valorEscolhidoSentimento}`;
        }
      }

      // Adicionar parâmetros de paginação
      const paginationParams = `&page=${page + 1}&limit=${rowsPerPage}`;
      const fullQuery = filtersQuery + paginationParams;

      const response = await v2_actionListaChatsSupervisao(fullQuery);

      // Debug: verificar estrutura da resposta da API
      console.log('API Response:', response.data);
      console.log('Pagination:', response.data.pagination);

      // Capturar o total de registros do objeto pagination da API
      const total = response.data.pagination?.totalItems || response.data.data.length;
      setTotalRegistros(total);

      if (isPesquisado) {
        setListaChatsPesquisa(response.data.data);
        setLoadingListaChats(false);
      } else {
        setListaChatsFiltro(response.data.data);
        setLoadingListaChats(false);
      }


    } catch (error) {
      setLoadingListaChats(false);
      console.log(error)
    }

  }

  const onLoad = async () => {
    await Promise.all([
      dispatch(getListaUsuariosTransferencia(user.clienteId)),
      dispatch(getListaSetoresTransferencia(user.clienteId)),
      buscarListaClientesCanais(),
      buscarListaTags()
    ]);
    // Recarregar a lista de chats
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
    buscarListaChats(querys, "filtrar", false);
  }


  useEffect(() => {
    onLoad()
  }, [location, periodo]);

  useEffect(() => {
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
    buscarListaChats(querys, "filtrar", false)
  }, [clienteIdPadrao]);

  // Recarregar dados quando página ou linhas por página mudarem
  useEffect(() => {
    if (clienteIdPadrao) {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
      buscarListaChats(querys, "filtrar", false);
    }
  }, [page, rowsPerPage]);

  // Recarregar dados quando os filtros mudarem
  useEffect(() => {
    if (clienteIdPadrao && !isPesquisado) {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      const querys = `?periodo=${periodo}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
      buscarListaChats(querys, "filtrar", false);
    }
  }, [valorEscolhidoUsuario, valorEscolhidoSetor, valorEscolhidoTag, valorEscolhidoSentimento, isPesquisado]);


  const handleChangeClienteIdPadrao = (value) => {
    console.log('value', value)
    setClienteIdPadrao(value)
    if (filterPesquisa.length > 0) {
      onPesquisarCanal(value)
    } else {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      const querys = `?periodo=${periodo}&cliente_id=${value}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
      buscarListaChats(querys, "filtrar", false)
    }

  }

  const onPesquisar = async () => {
    setIsPesquisado(true);
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=null&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=pesquisar&search=${filterPesquisa}`;
    await buscarListaChats(querys, "pesquisar", true)
  }

  const onPesquisarCanal = async (clienteId) => {
    setIsPesquisado(true);
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=null&cliente_id=${clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=pesquisar&search=${filterPesquisa}`;
    await buscarListaChats(querys, "pesquisar", true)
  }


  const onFiltrar = async (value, action) => {
    setIsPesquisado(false);
    setPeriodo(value)
    const inicio2 = moment(inicio).format("YYYY-MM-DD");
    const final2 = moment(final).format("YYYY-MM-DD");
    const querys = `?periodo=${value}&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=${action}`;
    await buscarListaChats(querys, "filtrar", false);
    setFilterPesquisa('')
  }


  async function handleOpenDetails(card) {
    setLoadingVerDetalhes(true);
    // Limpar informações do chat anterior antes de carregar novo
    dispatch(setLimparChatInfo());
    setOpenChatDetalhes(true);

    const res = await v2_actionBuscarChatById(card._id, null, user.id)
    setChat(res.data);
    dispatch(setChatInfo(res.data));
    // Aguardar um pouco para garantir que o estado foi limpo antes de carregar mensagens
    await new Promise(resolve => setTimeout(resolve, 100));
    dispatch(getMensagensWhatsappDb(res.data.sessao, res.data.numeroCliente));
    setLoadingVerDetalhes(false);
    console.log('handleOpenDetails', card);
  }

  const dataFiltered = applySortFilter({
    tableData,
    filterStatus
  });



  const handleGerarExcelChats = async () => {
    try {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      let querys = `?periodo=${periodo}&${valorEscolhidoUsuario ? `usuario_id=${user.id}` : ''}&cliente_id=${clienteIdPadrao}&inicio=${inicio2}&final=${final2}${valorEscolhidoTag ? `&filterTag=${valorEscolhidoTag}` : ''}${valorEscolhidoUsuario ? `&filterUser=${valorEscolhidoUsuario}` : ''}${valorEscolhidoSetor ? `&filterDepartament=${valorEscolhidoSetor}` : ''}${valorEscolhidoSentimento ? `&filterSentiment=${valorEscolhidoSentimento}` : ''}`;
      const response = await v2_actionGerarExcelRelatorioChats(querys);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `lais-chats-supervisao.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error)
    }
  }


  const handleGerarExcelChatsPrimeiroContato = async () => {
    try {
      const inicio2 = moment(inicio).format("YYYY-MM-DD");
      const final2 = moment(final).format("YYYY-MM-DD");
      let querys = `?periodo=${periodo}&${valorEscolhidoUsuario ? `usuario_id=${user.id}` : ''}&cliente_id=${clienteIdPadrao}&inicio=${inicio2}&final=${final2}${valorEscolhidoTag ? `&filterTag=${valorEscolhidoTag}` : ''}${valorEscolhidoUsuario ? `&filterUser=${valorEscolhidoUsuario}` : ''}${valorEscolhidoSetor ? `&filterDepartament=${valorEscolhidoSetor}` : ''}${valorEscolhidoSentimento ? `&filterSentiment=${valorEscolhidoSentimento}` : ''}`;
      const response = await v2_actionGerarExcelRelatorioChatsPrimeiroContato(querys);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `lais-chats.xlsx`);
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      console.log(error)
    }
  }

  const denseHeight = dense ? 56 : 76;

  const isNotFound =
    (!dataFiltered.length && !!filterName) ||
    (!dataFiltered.length && !!filterStatus);

  const filtrosAtivos =
    (!!valorEscolhidoUsuario ? 1 : 0) +
    (!!valorEscolhidoSetor ? 1 : 0) +
    (!!valorEscolhidoTag ? 1 : 0) +
    (!!valorEscolhidoSentimento ? 1 : 0);

  return (
    <div className={D.root} style={{ fontFamily: D.fontStack }}>
      {viewMode === 'table' && chat && (
        <DrawerChatWhatsapp
          chat={chat}
          open={openChatdetalhes}
          onClose={() => {
            setChat(null);
            setOpenChatDetalhes(false);
          }}
          listaFunil={listaFunil}
          source={'chat.supervisionar'}
        />
      )}

      <div className={D.stickyHeader}>
        <div className={D.container}>
          <div className={D.headerRow}>
            <h1 className={D.title}>Supervisão</h1>

            <div className={D.searchRow}>
              <div className={D.searchField}>
                <Input
                  className={D.searchInput}
                  placeholder="Pesquisar por nome ou número..."
                  value={filterPesquisa}
                  onChange={(e) => {
                    if (e.target.value.length === 0) {
                      setIsPesquisado(false);
                    }
                    setFilterPesquisa(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && filterPesquisa.length > 0) {
                      onPesquisar();
                    }
                  }}
                />
                {isPesquisado && filterPesquisa && (
                  <button
                    type="button"
                    onClick={() => {
                      setIsPesquisado(false);
                      setFilterPesquisa('');
                    }}
                    className={D.searchClear}
                    aria-label="Limpar pesquisa"
                  >
                    <Iconify icon="mdi:close-circle" width={16} />
                  </button>
                )}
                <button
                  type="button"
                  onClick={() => {
                    if (filterPesquisa.length > 0) onPesquisar();
                  }}
                  className={D.searchIcon}
                  aria-label="Buscar"
                >
                  <Iconify icon="eva:search-outline" width={18} />
                </button>
              </div>
            </div>

            <div className={D.topbarActions}>
              <div className={D.viewToggle}>
                <button
                  type="button"
                  onClick={() => setViewMode('table')}
                  className={viewMode === 'table' ? D.iconButtonActive : D.iconButton}
                  title="Visualização em tabela"
                >
                  <Iconify icon="mdi:table" width={18} />
                </button>
                <button
                  type="button"
                  onClick={() => setViewMode('split')}
                  className={viewMode === 'split' ? D.iconButtonActive : D.iconButton}
                  title="Visualização em painel"
                >
                  <Iconify icon="mdi:view-split-vertical" width={18} />
                </button>
              </div>

              <button type="button" onClick={onLoad} className={D.iconButton} title="Recarregar">
                <Iconify icon="mdi:reload" width={18} />
              </button>

              <SupervisaoExport
                className={D.ghostButton}
                onExportListChats={() => handleGerarExcelChats()}
                onExportListChatsPrimeiroContato={() => handleGerarExcelChatsPrimeiroContato()}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={D.body}>
        <div className={D.controlBar}>
          <div className={D.filterField}>
            <MenuDatas2
              anchorEl={anchorEl}
              open={openMenuDatas}
              onClose={() => setAnchorEl(false)}
              inicial={inicio}
              final={final}
              content={validaLabelMenuDatas(periodo, inicio, final)}
              customButton={
                <button
                  type="button"
                  className={D.periodButton}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
                >
                  <span className="truncate">{validaLabelMenuDatas(periodo, inicio, final)}</span>
                  <Iconify icon="mdi:calendar" className="h-4 w-4 text-[#a1a1aa]" />
                </button>
              }
              changeInicial={(newValue) => setInicio(newValue)}
              changeFinal={(newValue) => setFinal(newValue)}
              onSelect={(value) => {
                setAnchorEl(null);
                if (value) {
                  setPeriodo(value);
                  onFiltrar(value, 'filtrar');
                }
              }}
              onPesquisar={(start, end) => {
                if (start && end) {
                  setIsPesquisado(false);
                  setPeriodo(null);
                  setPage(0);
                  setFilterPesquisa('');
                  const inicio2 = moment(start).format('YYYY-MM-DD');
                  const final2 = moment(end).format('YYYY-MM-DD');
                  const querys = `?periodo=null&cliente_id=${isMultisession ? clienteIdPadrao : user.clienteId}&usuario_id=${user.id}&inicio=${inicio2}&final=${final2}&action=filtrar`;
                  buscarListaChats(querys, 'filtrar', false);
                } else {
                  onFiltrar('null', 'filtrar');
                }
              }}
            />
          </div>

          {isMultisession && (
            <div className={D.filterField}>
              <Select
                value={clienteIdPadrao || 'all'}
                onValueChange={(e) => {
                  const value = e === 'all' ? null : e;
                  handleChangeClienteIdPadrao(value);
                }}
              >
                <SelectTrigger className={D.filterSelect}>
                  <SelectValue placeholder="Canal" />
                </SelectTrigger>
                <SelectContent>
                  {listaClientesCanais.map((item) => (
                    <SelectItem key={item.cliente_id} value={item.cliente_id}>
                      {item.nome || 'undefined'}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}

          <Popover>
            <PopoverTrigger asChild>
              <button type="button" className={D.ghostButton}>
                Mais filtros
                {filtrosAtivos > 0 && <span className={D.filterCount}>{filtrosAtivos}</span>}
              </button>
            </PopoverTrigger>
            <PopoverContent className={D.popover} align="start">
              <h4 className={D.popoverTitle}>Filtros adicionais</h4>

              <div>
                <label className={D.popoverLabel}>Usuário</label>
                <Select
                  value={valorEscolhidoUsuario || 'all'}
                  onValueChange={(e) => {
                    const value = e === 'all' ? null : e;
                    setValorEscolhidoUsuario(value);
                    setPage(0);
                  }}
                >
                  <SelectTrigger className={D.filterSelect}>
                    <SelectValue placeholder="Todos" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Todos</SelectItem>
                    {listaUsuariosTransferencia.map((item) => (
                      <SelectItem key={item._id} value={item._id}>
                        {item.firstName}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <label className={D.popoverLabel}>Setor</label>
                <Select
                  value={valorEscolhidoSetor || 'all'}
                  onValueChange={(e) => {
                    const value = e === 'all' ? null : e;
                    setValorEscolhidoSetor(value);
                    setPage(0);
                  }}
                >
                  <SelectTrigger className={D.filterSelect}>
                    <SelectValue placeholder="Todos" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Todos</SelectItem>
                    {listaSetoresTransferencia.map((item) => (
                      <SelectItem key={item._id} value={item._id}>
                        {item.nome_setor}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <label className={D.popoverLabel}>Tag</label>
                <Select
                  value={valorEscolhidoTag || 'all'}
                  onValueChange={(e) => {
                    const value = e === 'all' ? null : e;
                    setValorEscolhidoTag(value);
                    setPage(0);
                  }}
                >
                  <SelectTrigger className={D.filterSelect}>
                    <SelectValue placeholder="Todos" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Todos</SelectItem>
                    {listaTags.map((item) => (
                      <SelectItem key={item._id} value={item._id}>
                        {item.nome}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              <div>
                <label className={D.popoverLabel}>Sentimento</label>
                <Select
                  value={valorEscolhidoSentimento || 'all'}
                  onValueChange={(e) => {
                    const value = e === 'all' ? null : e;
                    setValorEscolhidoSentimento(value);
                    setPage(0);
                  }}
                >
                  <SelectTrigger className={D.filterSelect}>
                    <SelectValue placeholder="Todos" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">Todos</SelectItem>
                    {[
                      { value: '1', label: '1' },
                      { value: '2', label: '2' },
                      { value: '3', label: '3' },
                      { value: '4', label: '4' },
                      { value: '5', label: '5' },
                    ].map((item) => (
                      <SelectItem key={item.value} value={item.value}>
                        {item.label}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </PopoverContent>
          </Popover>
        </div>

        {viewMode === 'table' ? (
          loadingListaChats ? (
            <div className={D.card}>
              <SkeletonSupervisionList />
            </div>
          ) : (
            <div className={D.card}>
              <div className={D.tabsWrap}>
                <Tabs
                  allowScrollButtonsMobile
                  variant="scrollable"
                  scrollButtons="auto"
                  value={filterStatus}
                  onChange={onChangeFilterStatus}
                  sx={{
                    minHeight: 48,
                    '& .MuiTab-root': {
                      minHeight: 48,
                      fontWeight: 600,
                      fontSize: 13,
                      textTransform: 'none',
                      color: '#71717a',
                      '&.Mui-selected': { color: '#7C3AED' },
                    },
                    '& .MuiTabs-indicator': { backgroundColor: '#7C3AED' },
                  }}
                >
                  {STATUS_OPTIONS.map((tab) => (
                    <Tab disableRipple key={tab.label} label={tab.label} value={tab.value} />
                  ))}
                </Tabs>
              </div>

              <div className={D.tableWrap}>
                <Scrollbar sx={{ flex: 1, minHeight: 0 }}>
                  <Table>
                    <TableHeader>
                      {TABLE_HEAD.map((item, index) => (
                        <TableHead key={index} className={D.tableHead}>
                          {item.label}
                        </TableHead>
                      ))}
                    </TableHeader>
                    <TableBody>
                      {dataFiltered.map((row) => (
                        <SupervisaoRow
                          key={row._id}
                          row={row}
                          chat={chat}
                          loading={loadingVerDetalhes}
                          selected={selected.includes(row.id)}
                          onSelectRow={() => onSelectRow(row.id)}
                          onViewRow={() => handleOpenDetails(row)}
                        />
                      ))}
                      <TableEmptyRows
                        height={denseHeight}
                        emptyRows={emptyRows(page, rowsPerPage, totalRegistros)}
                      />
                      <TableNoData isNotFound={isNotFound} />
                    </TableBody>
                  </Table>
                </Scrollbar>
              </div>

              <div className={D.pagination}>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component="div"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from} - ${to} de ${count !== -1 ? count : `mais de ${to}`}`
                  }
                  count={totalRegistros}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={onChangePage}
                  onRowsPerPageChange={onChangeRowsPerPage}
                  sx={{
                    '.MuiTablePagination-toolbar': { color: 'inherit' },
                    '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                      color: 'inherit',
                    },
                    '.MuiTablePagination-select': { color: 'inherit' },
                    '.MuiTablePagination-actions': { color: 'inherit' },
                  }}
                />
              </div>
            </div>
          )
        ) : (
          <div className={D.splitRoot}>
            <div className={D.statusSidebar}>
              <div className="flex flex-col items-center py-2 gap-0.5 flex-1">
                {STATUS_SIDEBAR_OPTIONS.map((item) => {
                  const isActive = filterStatus === item.value;
                  const count =
                    item.value === null
                      ? tableData.length
                      : tableData.filter((c) => c.statusRoom === item.value).length;

                  return (
                    <button
                      key={item.label}
                      type="button"
                      onClick={() => onChangeFilterStatus(null, item.value)}
                      className={cn(
                        D.statusItem,
                        isActive && D.statusItemActive,
                        isActive && item.activeBg,
                        isActive && item.activeBorder
                      )}
                      title={item.label}
                    >
                      <div
                        className={cn(
                          'w-8 h-8 rounded-lg flex items-center justify-center transition-colors',
                          isActive ? item.activeIcon : 'text-[#a1a1aa]'
                        )}
                      >
                        <Iconify icon={item.icon} width={20} />
                      </div>
                      <span
                        className={cn(
                          'text-[9px] font-semibold leading-tight text-center',
                          isActive ? item.activeLabel : 'text-[#a1a1aa]'
                        )}
                      >
                        {item.label}
                      </span>
                      {count > 0 && (
                        <span
                          className={cn(
                            'absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full text-[9px] font-bold flex items-center justify-center leading-none',
                            isActive ? `${item.dot} text-white` : 'bg-[#e4e4e7] text-[#52525b]'
                          )}
                        >
                          {count > 99 ? '99+' : count}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>

              <div className={D.statusTotal}>
                <div className="flex flex-col items-center gap-0.5">
                  <span className={D.statusTotalValue}>{totalRegistros}</span>
                  <span className={D.statusTotalLabel}>Total</span>
                </div>
              </div>
            </div>

            <div className={D.chatListCard}>
              <div className="flex-1 overflow-y-auto">
                {loadingListaChats ? (
                  <div className="p-4 space-y-3">
                    {[...Array(8)].map((_, i) => (
                      <div key={i} className="animate-pulse flex items-start gap-3">
                        <div className="w-9 h-9 rounded-full bg-[#e4e4e7]" />
                        <div className="flex-1 space-y-2">
                          <div className="h-3 bg-[#e4e4e7] rounded w-3/4" />
                          <div className="h-2 bg-[#e4e4e7] rounded w-1/2" />
                          <div className="h-2 bg-[#e4e4e7] rounded w-2/3" />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : dataFiltered.length === 0 ? (
                  <div className={D.emptyState}>
                    <div className={D.emptyIcon}>
                      <Iconify icon="mdi:chat-outline" width={24} />
                    </div>
                    <p className={D.emptyTitle}>Nenhum chat encontrado</p>
                    <p className={D.emptyDesc}>Ajuste os filtros para ver resultados</p>
                  </div>
                ) : (
                  dataFiltered.map((row) => (
                    <SupervisaoChatItem
                      key={row._id}
                      row={row}
                      isSelected={chat?._id === row._id}
                      onClick={() => handleOpenDetails(row)}
                    />
                  ))
                )}
              </div>

              {!loadingListaChats && dataFiltered.length > 0 && dataFiltered.length < totalRegistros && (
                <div className="border-t border-[#f0f0f3] flex-shrink-0">
                  <button
                    type="button"
                    onClick={() => {
                      onChangeRowsPerPage({ target: { value: rowsPerPage + 25 } });
                    }}
                    disabled={loadingListaChats}
                    className={D.loadMore}
                  >
                    {loadingListaChats
                      ? 'Carregando...'
                      : `Carregar mais (${dataFiltered.length} de ${totalRegistros})`}
                  </button>
                </div>
              )}
            </div>

            <div className={D.detailCard}>
              {loadingVerDetalhes ? (
                <div className={D.emptyState}>
                  <div className="w-8 h-8 border-2 border-[#7C3AED] border-t-transparent rounded-full animate-spin" />
                  <p className={`${D.emptyDesc} mt-3`}>Carregando conversa...</p>
                </div>
              ) : chatInfo ? (
                <ChatWindow
                  config={null}
                  chatInfo={chatInfo}
                  source="chat.supervisionar"
                  onCloseModal={() => {
                    setChat(null);
                    dispatch(setLimparChatInfo());
                  }}
                  hideSidebar={false}
                />
              ) : (
                <div className={D.emptyState}>
                  <div className={D.emptyIcon}>
                    <Iconify icon="mdi:monitor-dashboard" width={24} />
                  </div>
                  <p className={D.emptyTitle}>Selecione um chat</p>
                  <p className={D.emptyDesc}>
                    Escolha um chat na lista ao lado para visualizar a conversa e o atendimento.
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

// ----------------------------------------------------------------------

function applySortFilter({
  tableData,
  filterStatus
}) {

  if (filterStatus !== null) {
    tableData = tableData.filter((item) => item.statusRoom === filterStatus)
  }

  return tableData;
}

